export const ACTIVE_PROJECT_STATUSES = [
    'Lead / Klärung',
    'Interne Prüfung',
    'Angebot verschickt',
    'Angebot angenommen',
    'In Bearbeitung / Antragstellung',
    'In Bearbeitung / Antragserstellung',
    'Eingereicht/Begutachtung'
];

export const PROJECT_STATUSES = [
    'Lead / Klärung',
    'Interne Prüfung',
    'Angebot verschickt',
    'Angebot angenommen',
    'In Bearbeitung / Antragstellung',
    'In Bearbeitung / Antragserstellung',
    'Eingereicht/Begutachtung',
    'Bewilligt',
    'Teilrechnung gestellt',
    'Provision erhalten',
    'Abgelehnt',
    'Pausiert',
    'Abgebrochen',
    'Abgeschlossen'
];

export const PROJECT_STATUS_ORDER = [
    ...ACTIVE_PROJECT_STATUSES,
    'Bewilligt',
    'Teilrechnung gestellt',
    'Provision erhalten',
    'Aktiv',
    'In Bearbeitung',
    'Anfrage',
    'Entwurf',
    'Warten auf Kunde',
    'Pausiert',
    'Abgebrochen',
    'Abgelehnt',
    'Abgeschlossen'
];

export const PORTAL_STATUSES = ['Entwurf', 'Aktiv', 'Gesendet', 'Ausgefüllt', 'Geschlossen'];
export const ANSWER_STATUSES = ['Offen', 'Beantwortet', 'Unklar', 'Antwort reicht', 'Antwort reicht nicht', 'Intern geprüft'];
export const AI_EVALUATIONS = ['Nicht geprüft', 'Ausreichend', 'Zu vage', 'Unklar', 'Kritisch', 'Fehlt'];

export const normalizeStatus = (status) => String(status || '').trim().toLowerCase();

export const isActiveProjectStatus = (status) => {
    const normalizedStatus = normalizeStatus(status);
    return ACTIVE_PROJECT_STATUSES.some((activeStatus) => normalizeStatus(activeStatus) === normalizedStatus);
};
